export default __webpack_public_path__ + "static/media/Magadhi_cf_1.c5e93b65.mp3";